import { CopyOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Typography } from "antd";
import find from "lodash/find";
import PropTypes from "prop-types";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { COLORS } from "@/constants/Global";
import { SchemaBuilderDndHandle } from "@/modules/schema-builder/schema-builder-dnd";
import { Alert } from "@/ui/alert";

import "./Preview.style.less";

const GROUP_TITLE_MAXIMUM_LENGTH = 100;

const Preview = ({
  legend,
  fields = [],
  isDragged,
  dndProperties,
  dnd,
  notAllowedGroupNames,
  onGroupRename,
  onGroupCopy,
  onDeleteGroup,
  onAddField,
}) => {
  const { t } = useTranslation();
  const isSortingGroup = !!dndProperties;
  const [stateError, setStateError] = useState();

  const renameGroupName = (newGroupName) => {
    if (newGroupName === "" || newGroupName === legend) {
      return;
    }

    if (find(notAllowedGroupNames, { legend: newGroupName }) === undefined) {
      setStateError(false);
      onGroupRename(legend, newGroupName);
    } else {
      setStateError(true);
    }
  };

  const editableProps = {
    onChange: renameGroupName,
    maxLength: GROUP_TITLE_MAXIMUM_LENGTH,
  };

  const title = (
    <Typography.Title
      level={5}
      title={legend}
      editable={onGroupRename ? editableProps : undefined}
      className="editable-title"
    >
      {legend}
    </Typography.Title>
  );

  const extraSection = (
    <div style={{ display: "flex", gap: 10 }}>
      {onAddField && (
        <Button
          data-testid="add-field"
          icon={<PlusOutlined />}
          onClick={() => onAddField(legend)}
        >
          {t("form:addField")}
        </Button>
      )}
      {onGroupCopy && (
        <Button
          aria-label="copy-group"
          icon={<CopyOutlined />}
          onClick={() => onGroupCopy(legend)}
        >
          {t("form:copyGroup")}
        </Button>
      )}
      {onDeleteGroup && (
        <Button
          data-testid="delete-group"
          aria-label={t("form:deleteGroup")}
          title={t("form:deleteGroup")}
          icon={<DeleteOutlined />}
          danger
          onClick={() => onDeleteGroup(legend)}
        >
          {t("form:deleteGroup")}
        </Button>
      )}

      {isSortingGroup && <SchemaBuilderDndHandle {...dndProperties} />}
    </div>
  );

  return (
    <>
      <Alert
        display={stateError ?? false}
        title={t("form:error.groupAlreadyExists", { name: legend })}
        closable={false}
      />
      <Card
        data-testid="group"
        title={title}
        style={{
          backgroundColor: isDragged ? COLORS.DRAGGED_BACKGROUND : COLORS.WHITE,
        }}
        className="group-preview-card"
        extra={extraSection}
        styles={{ body: dnd && { padding: 0 } }}
      >
        {fields}
      </Card>
    </>
  );
};

Preview.propTypes = {
  legend: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  onGroupRename: PropTypes.func,
  onGroupCopy: PropTypes.func,
  onDeleteGroup: PropTypes.func,
  onAddField: PropTypes.func,
  notAllowedGroupNames: PropTypes.array,
  fields: PropTypes.array,
  isDragged: PropTypes.bool,
  dndProperties: PropTypes.any,
  dnd: PropTypes.bool,
};

export default Preview;
